import ReactivateModal from './reactivate-modal';

export default ReactivateModal;
